import { stopPropagation } from '../../utils/event';
import { Link } from '../../components/Link';
import { usePublisher } from '../../hooks';

export function AgentShowMoreOffersContainer() {
  const { moreOffersLink } = usePublisher();

  if (!moreOffersLink) {
    return null;
  }

  return <Link target="_blank" href={moreOffersLink} onClick={stopPropagation} text="Посмотреть все объекты" />;
}
